import { Tag } from 'antd';
import { colors } from 'theme/tokens';
import { KcSummary } from '../types';
import { TREND_META, formatNumber, milestoneColor, trendKeysFor } from '../utils';
import styles from '../style.module.scss';

interface Props {
  /** null = chưa có số (đang tải lần đầu hoặc tải lỗi): ô hiện "—". */
  summary: KcSummary | null;
  closed: boolean;
  /** Mọi mốc đang có, tăng dần — để tô màu thẻ mốc giống bảng. */
  milestoneOrder: number[];
}

/**
 * Ô tóm tắt: số Creator đạt mốc (Hiện / Ẩn), số theo xu hướng và số theo mốc cao nhất.
 * Tháng đang chạy không có ô "Giảm"; tháng đã khép không có ô "Chưa giữ mốc" (đặc tả §2, Q1).
 */
const SummaryTiles = ({ summary, closed, milestoneOrder }: Props) => {
  const byMilestone = (summary?.byMilestone || [])
    .slice()
    .sort((a, b) => b.milestone - a.milestone);

  return (
    <>
      <ul className={styles.tiles} aria-label="Tóm tắt Creator đạt mốc">
        <li className={styles.tile}>
          <span className={styles.tileHead}>
            <span className={styles.tileDot} style={{ background: colors.accent }} aria-hidden />
            <span className={styles.tileLabel}>Creator đạt mốc</span>
          </span>
          <span className={styles.tileValue}>{summary ? formatNumber(summary.creators) : '—'}</span>
          <span className={styles.tileHint}>
            {summary
              ? `Đang hiện ${formatNumber(summary.visible)} · Đã ẩn ${formatNumber(summary.hidden)}${
                  summary.excluded ? ` · Loại trừ ${formatNumber(summary.excluded)}` : ''
                }`
              : 'Đang hiện — · Đã ẩn —'}
          </span>
        </li>
        {trendKeysFor(closed).map((key) => {
          const meta = TREND_META[key];
          return (
            <li key={key} className={styles.tile}>
              <span className={styles.tileHead}>
                <span className={styles.tileDot} style={{ background: meta.ink }} aria-hidden />
                <span className={styles.tileLabel}>{meta.label}</span>
              </span>
              <span className={styles.tileValue} style={{ color: summary ? meta.ink : undefined }}>
                {summary ? formatNumber(summary.trend[key]) : '—'}
              </span>
              <span className={styles.tileHint}>{meta.hint}</span>
            </li>
          );
        })}
      </ul>

      {byMilestone.length > 0 && (
        <div className={styles.byMilestone}>
          <span className={styles.byMilestoneLabel}>Theo mốc cao nhất:</span>
          {byMilestone.map((item) => (
            <Tag key={item.milestone} color={milestoneColor(item.milestone, milestoneOrder)}>
              {item.label} · {formatNumber(item.count)}
            </Tag>
          ))}
        </div>
      )}
    </>
  );
};

export default SummaryTiles;
